// removed by extract-text-webpack-plugin
module.exports = {"root":"SelectSingleFilterPopup__root__27e6C","menuLabel":"SelectSingleFilterPopup__menuLabel__2my1i","menuLabelSelected":"SelectSingleFilterPopup__menuLabelSelected__1W4Yj","menuContent":"SelectSingleFilterPopup__menuContent__2IxWu","menuItemBorder":"SelectSingleFilterPopup__menuItemBorder__dE69P","menuItemBorderSelected":"SelectSingleFilterPopup__menuItemBorderSelected__15TQZ","menuItem":"SelectSingleFilterPopup__menuItem__2NA2d","clearMenuItem":"SelectSingleFilterPopup__clearMenuItem__2fD9R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectSingleFilter/SelectSingleFilterPopup.css
// module id = 2107
// module chunks = 0